<div class="section-panel">
  @if (fieldParameterList) {
    <ng-container>
      @for (fieldParameters of fieldParameterList; track $index) {
        <div class="section-panel__field">
          <div class="section-panel-edit-field {{styleClass}}">
            <div class="section-panel-edit-field__view">
              <div class="section-panel-edit-field__view-title">
                @if (fieldParameters.field.$$inlineView?.icon) {
                  @if (fieldParameters.field.$$inlineView?.icon.startsWith('icon-')) {
                    <i
                      [ngClass]="fieldParameters.field.$$inlineView?.icon"
                    ></i>
                  } @else {
                    <mat-icon>
                      {{ fieldParameters.field.$$inlineView?.icon }}
                    </mat-icon>
                  }
                }

                <span class="bold">
                  {{ fieldParameters.field.title | translate }}
                </span>
              </div>

              <div class="section-panel-edit-field__view-content">
                @if (fieldParameters.field.edit) {
                  <app-edit-field-input
                    [fieldParameters]="fieldParameters"
                    [disabled]="!edit"
                  ></app-edit-field-input>
                } @else if (fieldParameters.field.field_type === 'map_id') {
                  {{ sectionsContainer.rootObject[fieldParameters.field.name + '_value'] }}
                } @else if (fieldParameters.field.field_type === 'date_time_iso') {
                  {{ dateTools.isoDateToString(sectionsContainer.rootObject[fieldParameters.field.name]) }}
                } @else {
                  {{ sectionsContainer.rootObject[fieldParameters.field.name] }}
                }
              </div>
            </div>
          </div>
        </div>
      }
    </ng-container>
  }
</div>
